import { SVGProps } from "react";

export function Bell(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.158 11.991C5.085 13.387 5.169 14.873 3.922 15.808C3.63531 16.0225 3.40266 16.3011 3.24259 16.6214C3.08253 16.9417 2.99946 17.2949 3 17.653C3 18.65 3.782 19.5 4.8 19.5H19.2C20.218 19.5 21 18.65 21 17.653C21 16.927 20.658 16.243 20.078 15.808C18.831 14.873 18.915 13.387 18.842 11.991C18.752 10.2371 17.9919 8.58471 16.7186 7.3751C15.4454 6.1655 13.7562 5.49106 12 5.49106C10.2438 5.49106 8.55462 6.1655 7.28136 7.3751C6.0081 8.58471 5.24799 10.2371 5.158 11.991Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 19.5C15 20.2956 14.6839 21.0587 14.1213 21.6213C13.5587 22.1839 12.7956 22.5 12 22.5C11.2044 22.5 10.4413 22.1839 9.87868 21.6213C9.31607 21.0587 9 20.2956 9 19.5M10.5 3.625C10.5 4.453 11.172 5.5 12 5.5C12.828 5.5 13.5 4.453 13.5 3.625C13.5 2.797 12.828 2.5 12 2.5C11.172 2.5 10.5 2.797 10.5 3.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
